(() => {
  if (window.RollMyLogoUX || window.Shopify?.designMode || document.body.hasAttribute('data-rml-preview')) return;
  const actions = [
    'CustomSize_Standard', 'CustomSize_Wide', 'CustomSize_ExtraWide',
    ...['Black', 'Blue', 'Red', 'Green', 'White', 'Yellow'].flatMap(color => [`CustomInk_${color}`, `ReadyInk_${color}`, `Marker_Add${color}`]),
    'Logo_UploadNow', 'Logo_SendLater', 'Logo_ChooseFile', 'Logo_RemoveFile', 'Custom_Continue',
    'Custom_CompareSizes', 'Ready_CompareSizes', 'Compare_DownloadPDF', 'Compare_ApplySize', 'Compare_Close',
    'ReadySize_S', 'ReadySize_M', 'ReadySize_L', 'Ready_ToggleInverse', 'Ready_AddButton',
    'Help_CopyEmail', 'Help_Open', 'Help_Gmail', 'Help_Outlook', 'Help_EmailApp',
    'Business_OpenQuote', 'Business_CloseQuote', 'Video_PlayPause',
    'FAQ_Surfaces', 'FAQ_Included', 'FAQ_Production', 'FAQ_Replacement', 'FAQ_MarkerLife', 'FAQ_Ink',
    'Cart_CheckoutButton', 'Cart_Update', 'Cart_Remove', 'Header_Cart', 'Header_Account',
    ...['Hero', 'Nav', 'Footer', 'Cart', 'FAQ'].flatMap(area => ['BuildRoller', 'ReadyMade', 'HowItWorks', 'FAQ', 'Markers'].map(destination => `${area}_${destination}`)),
    'OrderViewed', 'ArtworkReady', 'FileValidated', 'FileRejected', 'MissingLogo',
    'AddStarted', 'AddSucceeded', 'AddFailed', 'AddUnconfirmed', 'CartViewed',
  ];
  const allowed = new Set(actions.map(name => `RML_${name}`));
  function track(name) {
    try {
      if (!allowed.has(name) || typeof window.clarity !== 'function'
        || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return false;
      window.clarity('event', name);
      return true;
    } catch { return false; }
  }
  window.RollMyLogoUX = { track };
  const root = document.querySelector('[data-custom-order-only] .rml-logo-choice__head');
  let viewed = false;
  const observer = root && window.IntersectionObserver ? new IntersectionObserver(entries => {
    if (!viewed && entries.some(entry => entry.isIntersecting) && track('RML_OrderViewed')) {
      viewed = true; observer.disconnect();
    }
  }, { threshold: .15 }) : null;
  const cart = document.querySelector('.rml-cart-page');
  let cartViewed = false;
  function refresh() {
    if (!viewed && observer) { observer.unobserve(root); observer.observe(root); }
    if (cart && !cartViewed) cartViewed = track('RML_CartViewed');
  }
  refresh();
  document.addEventListener('visitorConsentCollected', refresh);
  window.addEventListener('load', refresh, { once: true });
})();
